import React from 'react'

function ColorBar({}) {
    return <svg xmlns="http://www.w3.org/2000/svg"  width="368" height="41" viewBox="0 0 368 41" >
        <defs>
            <linearGradient id="linear-gradient" y1="0.61" x2="1" y2="0.61" gradientUnits="objectBoundingBox">
                <stop offset="0" stopColor="#f8f32b"/>
                <stop offset="0.192" stopColor="#e18b00"/>
                <stop offset="0.489" stopColor="#e18b00"/>
                <stop offset="0.77" stopColor="#e18b00"/>
                <stop offset="1" stopColor="#a31621"/>
            </linearGradient>
        </defs>
        <rect id="Rectangle_21" data-name="Rectangle 21" width="368" height="41" fill="url(#linear-gradient)" />
    </svg>
}
export default ColorBar;
